import { p as proxyCustomElement, H, h, c as Host } from './p-23afa4c1.js';
import { d as defineCustomElement$1 } from './p-0f8558ea.js';
import { b as bem } from './p-a05fe53c.js';

const cosmosSelectValueCss = ":host{display:block;height:100%;max-width:100%;position:relative}:host([multiple]){display:inline}.cosmos-select-value{--cosmos-text-color:currentColor;-ms-flex-align:center;align-items:center;border-radius:4px;-webkit-box-sizing:border-box;box-sizing:border-box;cursor:default;display:-ms-inline-flexbox;display:inline-flex;margin:0;max-width:100%;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%}.cosmos-select-value--multiple{display:inline}.cosmos-select-value--multiple ::slotted([slot=prefix]){display:inline-block;margin-bottom:2px;vertical-align:middle}.cosmos-select-value__label{overflow:hidden}.cosmos-select-value--multiple .cosmos-select-value__label{display:inline}.cosmos-select-value ::slotted([slot=prefix]){-ms-flex:0 0 auto;flex:0 0 auto;-webkit-margin-end:var(--cosmos-select-gap, 6px);margin-inline-end:var(--cosmos-select-gap, 6px);--cosmos-icon-size:18px;--cosmos-flag-width:18px;--cosmos-avatar-size:18px}";
const CosmosSelectValueStyle0 = cosmosSelectValueCss;

const generateClassNames = bem('cosmos-select-value');
const CosmosSelectValue = /*@__PURE__*/ proxyCustomElement(class CosmosSelectValue extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.handleSlotChange = (event) => {
            if (this.multiple) {
                const slot = event.target;
                const nodes = slot.assignedNodes();
                nodes.forEach((node) => {
                    var _a, _b;
                    if (node.nodeType === Node.TEXT_NODE) {
                        node.textContent = (_b = (_a = node.textContent) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : ''; // Trim the inline text
                    }
                });
            }
        };
        this.multiple = false;
    }
    render() {
        return (h(Host, { key: 'ab2a0db3858746f02205c5d5d000c265745d7468' }, h("div", { key: '8dd166e40cb1f77af30d6db9720235c397d6e8f1', class: generateClassNames({ multiple: this.multiple }), part: "base" }, h("slot", { key: 'f8a45e6c2e1d1aea93364a1e3e5ed93ce5d0c8b6', "aria-hidden": "true", name: "prefix" }), h("cosmos-text", { key: '87eaedbcf09dd779f29e87537de87f68f97922c7', clamp: 1, class: generateClassNames('label'), exportparts: "base: label", size: "small", tag: this.multiple ? 'span' : 'p' }, h("span", { key: 'be029548b83cfc8ca23400f395099e355489a75d' }, h("slot", { key: '7c5011862640a52496d07febc9df8269a9111c83', onSlotchange: this.handleSlotChange }))))));
    }
    get element() { return this; }
    static get style() { return CosmosSelectValueStyle0; }
}, [1, "cosmos-select-value", {
        "multiple": [516]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-select-value", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-select-value":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosSelectValue);
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { CosmosSelectValue as C, defineCustomElement as d };
